// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0Wkvl","footer-container":"Footer_footer-container__v0PGb","footer-col":"Footer_footer-col__UfQcf","footer-link":"Footer_footer-link__x1jOc"};